import { motion } from "framer-motion";

// Masked line-by-line reveal. Pass an array of lines (strings) or nodes.
export const MaskedReveal = ({
  lines = [],
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.12,
  as: Tag = "h2",
  testId,
}) => {
  return (
    <Tag className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <span
          key={i}
          className="block overflow-hidden"
          style={{ paddingBottom: "0.08em" }}
        >
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            whileInView={{ y: "0%" }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{
              duration: 0.9,
              ease: [0.22, 1, 0.36, 1],
              delay: delay + i * stagger,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

// Simple fade-up wrapper for blocks.
export const FadeUp = ({ children, delay = 0, className = "", testId }) => (
  <motion.div
    className={className}
    data-testid={testId}
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8%" }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay }}
  >
    {children}
  </motion.div>
);
